import { Briefcase, GraduationCap, Award, Star, Sparkles } from "lucide-react";

const ICONS = {
  employment: Briefcase,
  education: GraduationCap,
  certificate: Award,
  recommendation: Star,
};

export default function Timeline({ items = [] }) {
  if (items.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-ec-ink-soft" data-testid="timeline-empty">
        Your career timeline will appear here as you add records.
      </div>
    );
  }
  return (
    <ol className="relative border-l-2 border-dashed border-ec-line ml-3 space-y-6 pl-6" data-testid="timeline">
      {items.map((it, i) => {
        const Icon = ICONS[it.type] || Sparkles;
        return (
          <li key={i} className="relative" data-testid={`timeline-item-${i}`}>
            <span className="absolute -left-[35px] top-1 w-6 h-6 bg-white border-2 border-ec-ink rounded-full flex items-center justify-center">
              <Icon className="w-3 h-3 text-ec-ink" />
            </span>
            <div className="flex items-baseline gap-3">
              <span className="font-mono-plex font-bold text-ec-emerald">{it.year}</span>
              <span className="font-display font-semibold text-base">{it.title}</span>
            </div>
            <div className="text-sm text-ec-ink-soft mt-0.5">{it.org}</div>
          </li>
        );
      })}
    </ol>
  );
}
